<template>
  <header class="bg-white shadow p-2">
    <div class="container mx-auto flex justify-between items-center px-2 md:px-3">
      <!-- Logo -->
      <div :class="{ hidden: isMenuOpen, block: !isMenuOpen }" class="flex flex-row items-center justify-start lg:w-[420px]">
        <router-link to="/">
          <img src="../assets/images/logo/logo.webp" alt="Logo thiết kế website chuẩn SEO" class="h-[44px] md:h-[60px] lg:h-[80px]"/>
        </router-link>

        <router-link to="/" class="hidden lg:block">
          <h1 class="custom-font text-yellow-600 ml-[40px] text-[32px]">
            Web services
          </h1>
        </router-link>
      </div>

      <!--------------- NAVIGATION --------------->
      <nav class="ml-auto">
        <!-- Nút hamburger chỉ hiển thị trên di động -->
        <button @click="toggleMenu" class="btn_custom block md:hidden ml-auto">
          <svg v-if="!isMenuOpen" class="w-6 h-6 hamburger" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
          <svg v-else class="w-6 h-6 close" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        <!-- Menu điều hướng -->
        <ul :class="menuClasses">
          <li @click="toggleMenu">
            <router-link to="/" class="item lg:text-[20px] md:text-[17px] block lg:px-3 md:px-1 text-blue-600 font-medium py-[4px]">
              HOME
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/about" class="item lg:text-[20px] md:text-[17px] block lg:px-3 md:px-1 text-blue-600 font-medium py-[4px]">
              ABOUT
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/contact" class="item lg:text-[20px] md:text-[17px] block lg:px-3 md:px-1 text-blue-600 font-medium py-[4px]">
              CONTACT
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/web-guide" class="item lg:text-[20px] md:text-[17px] block lg:px-3 md:px-1 text-blue-600 font-medium py-[4px]">
              WEB GUILDE
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/social-services" class="item lg:text-[20px] md:text-[17px] block lg:px-3 md:px-1 text-blue-600 font-medium py-[4px]">
              SOCIAL
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/blog" class="item lg:text-[20px] md:text-[17px] block lg:px-3 md:px-1 text-blue-600 font-medium py-[4px]">
              BLOG
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, computed } from "vue";

const isMenuOpen = ref(false);

const toggleMenu = () => {
  if (window.innerWidth < 768) {
    isMenuOpen.value = !isMenuOpen.value;
  }
};

const menuClasses = computed(() => ({
  hidden: !isMenuOpen.value,
  block: isMenuOpen.value,
  'md:flex': true,
  'md:flex-row': true,
  'md:space-x-2': true,
  'w-full': true,
  'animate-in': isMenuOpen.value,
  'animate-out': !isMenuOpen.value,
}));

</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Righteous);

.custom-font {
  font-family:'Black Ops One', 'Righteous', Arial, sans-serif;
  letter-spacing: 2px;
}

.btn_custom .hamburger {
  animation: rotation_open 0.5s ease-in-out;
}

.btn_custom .close {
  animation: rotation_close 0.5s ease-in-out;
}

@keyframes rotation_open {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes rotation_close {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(0);
  }
}

/* Animations */
.animate-in {
  animation: slide-in 0.7s ease-in-out;
}

.animate-out {
  animation: slide-out 0.7s ease-in-out;
}

@keyframes slide-in {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
}

.item {
  text-decoration:none;
  transition:0.3s ease-in-out;
}

.item:hover {
  transform:scale(1.2);
  -webkit-transform:scale(1.2);
}
</style>
